module.exports = __webpack_public_path__ + "img/main_graphic_l720.ed9efb15.png";